import { alertWithMessage } from "components/modal/message_modal";
import UboxRewardShow from "components/view/ubox_reward_show";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { wheels } from "lib/udiamond_reward_list";
import get_iphone_reward, {
  GetIPhoneRewardResponse,
} from "lib/worker/api/get_iphone_reward";
import { prefix } from "lib/worker/client";
import { GetServerSideProps } from "next";
import Link from "next/link";
import { useState } from "react";
import { useEffect } from "react";
import Img from "react-cloudimage-responsive";
import LayoutMaster from "../../components/layout/layout_master";

interface Props {
  infomation: CheckWithPrefixResponse;
}

function Uspin(props: Props) {
  const [iphoneRewards, setiPhoneRewards] =
    useState<GetIPhoneRewardResponse[]>();

  useEffect(() => {
    get_iphone_reward({ prefix: prefix ?? "" })
      .then((json) => {
        setiPhoneRewards(json);
      })
      .catch((error) => {
        alertWithMessage(error.response.data.message);
      });
  }, []);

  return (
    <LayoutMaster
      content_setting={{
        title: "กงล้อลุ้นโชค uSpin ลุ้นรับ iPhone 13 Pro",
        description:
          "รับ uDiamond มากมาย จากการ หมุน uSpin เข้าเล่น ท่านมีสิทธิ ได้รับ รางวัลใหญ่ เป็น iPhone 13 Pro ทั้งยัง สามารถนำ uDiamond ไปใช้กับ กิจกรรม uGames อื่นๆ",
      }}
      information={props.infomation}
    >
      <div className="container" style={{ paddingTop: 20 }}>
        <h1 className="text-center">
          <span>กงล้อลุ้นโชค uSpin</span>
        </h1>
        <p className="text-center">ลุ้นรับ iPhone 13 Pro</p>
        <div className="margin-top-20">
          <Img
            ratio={2.8 / 1}
            src="uspin-iphone-ugame-3.png"
            alt="หมุนเลย ลุ้นรับ iPhone 13 Pro"
          ></Img>
        </div>
        <div className=" col-8 col-md-4 col-lg-3 row center-row-content">
          <div className="text-center  bg-invite button-glowing margin-bottom-20 margin-top-30">
            <Link href="https://snambet.com/uspin">
              <a style={{ color: "white", textDecoration: "none" }}>
                หมุนเลย ลุ้นรับ iPhone 13 Pro
              </a>
            </Link>
          </div>
        </div>
        <h2 className="margin-top-20">
          ผู้โชคดีที่ได้รับรางวัล iPhone 13 Pro (256 GB) ฟรี 1 เครื่อง
        </h2>
        <div>
          {(iphoneRewards ?? []).map((value) => {
            return (
              <>
                <UboxRewardShow
                  List={value.Note ?? "-"}
                  Name={value.Username}
                  Pc={value.DisplayCreatedAt}
                ></UboxRewardShow>
              </>
            );
          })}
        </div>
        <div className="margin-top-10">
          <div className="col-12 col-md-6 center-row-content">
            <Img
              ratio={1.3}
              src="snambetiphone13pro.png"
              alt="กงล้อลุ้นโชคแจก IPHONE 13 PRO"
            ></Img>
          </div>
        </div>
        <div className="margin-top-20">
          <h4 className="text-title">
            <span>วิธีการ</span>
          </h4>
          <p>เล่น เกมกงล้อลุ้นรางวัล แจ็คพอตแตก แจก iPhone 13 Pro</p>
          <li>
            ท่านต้องใช้ <span>30 uDiamond (เพชร)</span> เพื่อ{" "}
            <span>หมุนสปิน</span>
          </li>
          <li>
            เริ่มเสี่ยงโชคโดยการ กดไปที่ปุ่ม <span>หมุนเลย iPhone 13 Pro</span>
          </li>
          <li>จะมีหน้าต่างเล่นเกม กงล้อลุ้นโชค (uSpin)</li>
          <li>จากนั้นกด START เพิ่มเริ่มหมุนสปินลุ้นรับรางวัลใหญ่</li>
          <br></br>
          <h4>
            <span>ของรางวัลที่ร่วมรายการ</span>
          </h4>
          <li>ไม่ได้รับรางวัล</li>
          <li>
            ได้รับ uDiamond (เพชร) ตั้งแต่ <span>20</span> จนถึง{" "}
            <span>1,000 uDiamond</span> (เพชร){" "}
          </li>
          <li>
            รางวัลใหญ่ แจ็คพอตแตกได้รับ <span>iPhone 13 Pro</span>
          </li>
        </div>
        <div>
          {(wheels ?? []).map((value) => {
            return (
              <>
                <UboxRewardShow
                  List={value.list}
                  Name={value.name}
                  Pc={value.pc}
                ></UboxRewardShow>
              </>
            );
          })}
        </div>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

export default Uspin;
